import {
  isObject as lodashIsObject,
  isArray,
  isNil,
  transform,
  isEqual,
} from 'lodash';

/**
 * Ensure the object is an object
 * @param {Object} obj
 * @returns {Object}
 */
export const ensureObject = obj =>
  lodashIsObject(obj) && !isArray(obj) ? obj : {};

export const isObjEmpty = obj =>
  Object.values(ensureObject(obj)).every(val => isNil(val));

export const isObject = obj =>
  typeof obj === 'object' && !Array.isArray(obj) && obj !== null;

/**
 * i.e. const payload = { ...conditionalObject(condition, obj) };
 * @param condition {bool}
 * @param objOne {Object}
 * @param objTwo {Object} - optional
 * @returns {Object}
 */
export const conditionalObject = (condition, objOne, objTwo = {}) =>
  condition ? objOne : objTwo;

const changes = (object, base) =>
  transform(object, (result, value, key) => {
    if (!isEqual(value, base[key])) {
      // eslint-disable-next-line no-param-reassign
      result[key] =
        isObject(value) && isObject(base[key])
          ? changes(value, base[key])
          : value;
    }
  });

/**
 * Find difference between two objects
 * @param  {object} origObj - Source object to compare newObj against
 * @param  {object} newObj  - New object with potential changes
 * @return {object} differences
 */
export const getDifference = (object, base) => changes(object, base);
